module.exports = __webpack_public_path__ + "img/cww_08.f91b49fe.jpg";